import { useState } from 'react'
import { Notice } from '../Toast'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getCareers, setCareers } from '../api/endpoints'
import type { Careers } from '../api/types'
import { ErrorNotice } from '../components'
import HowItWorks from '../HowItWorks'

const lines = (v: string) => v.split('\n').map((l) => l.trim()).filter(Boolean)

export default function CareersPage() {
  const list = useQuery({ queryKey: ['careers'], queryFn: getCareers })
  return (
    <div>
      <h1>Study areas and careers</h1>
      <HowItWorks id="careers" title="How suggestions work" steps={[
        { icon: 'check', title: 'The strongest three', text: 'A report looks at a candidate’s three strongest intelligences.' },
        { icon: 'content', title: 'Your wording', text: 'It lists the study areas and careers you write here for those intelligences, without repeats.' },
        { icon: 'shield', title: 'Yours alone', text: 'Each institution has its own lists. Nobody else sees or changes yours.' },
      ]} />
      <ErrorNotice error={list.error} />
      <div className="grid">{list.data?.map((c) => <CareerCard key={c.code} item={c} />)}</div>
    </div>
  )
}

function CareerCard({ item }: { item: Careers }) {
  const queryClient = useQueryClient()
  const [degrees, setDegrees] = useState(item.degrees.join('\n'))
  const [careers, setCareersText] = useState(item.careers.join('\n'))
  const [saved, setSaved] = useState(false)
  const save = useMutation({ mutationFn: () => setCareers(item.code, { degrees: lines(degrees), careers: lines(careers) }), onSuccess: async () => { setSaved(true); await queryClient.invalidateQueries({ queryKey: ['careers'] }) } })
  return (
    <form className="card" onSubmit={(e) => { e.preventDefault(); setSaved(false); save.mutate() }}>
      <h2>{item.name}</h2>
      <label className="field">Study areas (one per line)<textarea rows={5} value={degrees} onChange={(e) => setDegrees(e.target.value)} /></label>
      <label className="field">Careers (one per line)<textarea rows={5} value={careers} onChange={(e) => setCareersText(e.target.value)} /></label>
      <ErrorNotice error={save.error} />
      {saved && <Notice tone="ok">Saved.</Notice>}
      <button type="submit" className="primary" disabled={save.isPending}>{save.isPending ? 'Saving…' : 'Save'}</button>
    </form>
  )
}
